import styled from 'styled-components';

const ActionLabel = styled.span`
  color: ${({ theme }) => theme.colors.corporateRed};
  font-family: ${({ theme }) => theme.fonts.mainFont};
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  flex: 1 0 auto;
  padding: 10px 0;
`;

export default ActionLabel;
